import firebase from 'firebase/app'


const afterLogin = uid => async (dispatch) => {
  dispatch({ type: 'LOGIN' })
  const snapshot = await firebase.firestore().collection('permissions').doc(uid).get()

  if (snapshot.exists) {
    const data = snapshot.data()

    if (data.role !== process.env.REACT_APP_SITE_ENV) {
      dispatch({ type: 'LOGOUT' })
      return dispatch({
        pathname: '/',
        type: 'LOGIN_ERROR',
        message: 'Vous n\'avez pas la permission d\'accéder aux contenus',
      })
    }

    const userSnapshot = await firebase.firestore().collection('users').doc(uid).get()
    return dispatch({
      uid,
      data: userSnapshot.data(),
      type: 'LOGIN_SUCCESS',
    })
  }

  return dispatch({
    type: 'LOGIN_ERROR',
    message: 'Utilisateur introuvable',
  })
}

export const onAuthChange = user => (dispatch) => {
  dispatch({
    type: 'AUTH_CHANGED',
    uid: user ? user.uid : null,
    isAnonymous: user && user.isAnonymous,
  })

  if (user && user.uid && !user.isAnonymous) {
    dispatch(afterLogin(user.uid))
  }

  if (!user) {
    dispatch({ type: 'LOGOUT' })
  }
}


export const logout = () => (dispatch) => {
  firebase.auth().signOut()
  dispatch({ type: 'LOGOUT' })
}


export const editPassword = ({ password }) => async (dispatch) => {
  dispatch({ type: 'LOADING' })
  const user = firebase.auth().currentUser

  try {
    await user.updatePassword(password)
    dispatch({
      type: 'SNACK_SUCCESS',
      message: 'Le mot de passe a bien été modifié',
    })
  } catch (err) {
    dispatch({
      type: 'SNACK_ERROR',
      message: err.message,
    })
  }

  dispatch({ type: 'UNLOAD' })
}


export const login = (email, password) => async (dispatch) => {
  dispatch({ type: 'LOGIN' })

  try {
    await firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    await firebase.auth().signInWithEmailAndPassword(email, password)
  } catch (err) {
    let message = ''

    switch (err.code) {
      case 'auth/user-not-found': message = 'Impossible de se connection : E-mail ou mot de passe erronés'
        break
      default: message = `Une erreur est survenue (${err.code})`
        break
    }

    dispatch({
      message,
      type: 'LOGIN_ERROR',
    })

    throw err
  }
}
